<template> 
     <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div class="row m-0 formdynamic justify-content-md-between" style="padding-top:10px;" v-if="form_data.response_type === 1">
                    <div v-for="(item, i) in form_data.answers_data" :key="i" :class="'col-md-12'" class="p-0 formdynamic__item" :style="`margin-top:20px`">
                        <div class="formdynamic__item__field">
                            <label v-html="`Answer #${i+1} <b style='color:red;'>*</b>`" class="modal-label"/>
                            <input
                                :type="'text'" 
                                :maxlength="'150'"
                                :required="true"
                                v-model="item.answer_text"
                            />
                        </div>
                    </div>
                    <div class="modal__buttons text-center text-md-right">
                        <button 
                            v-if="form_data.answers_data.length < 5"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Add answer <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" 
                            style="margin-left:0px;"
                            @click="pushAnswerField()"
                        />
                        <button 
                            v-if="form_data.answers_data.length+1 > 3"
                            type="button"
                            class="modal__buttons__item" 
                            v-html="`Remove last answer`"
                            :style="form_data.answers_data.length >= 5 ? `margin-left:0px;` : ''"
                            @click="spliceLastAnswerField()"
                        />
                    </div>
                </div>
                <!-- <pre>
                    {{ form_data.answers_data }}
                </pre> -->
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "parent_id",
        "rest_api",
        "notifications",
        "notyf",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data: FormResources.form_data,
            form_format: FormResources.form_format,
            form_backup: {...FormResources.form_data},
        }
    },

    methods:{

        pushAnswerField()
        {
            this.form_data.answers_data.push(
                {
                    answer_text: '',
                },
            )
        },

        spliceLastAnswerField()
        {
            this.form_data.answers_data.splice(this.form_data.answers_data.length-1, 1)
        },

    },

    watch: {
        parent_id(val) 
        {
            this.form_data.survey_id = val
            this.form_backup.survey_id = val
        }
    },
    mounted(){

    }
    
}
</script>